"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var ts_md5_1 = require("ts-md5"),
    DeviceUtils = function () {
  function e() {}

  return e.isIOS = function () {
    return /iPad|iPhone|iPod|Intel Mac/.test(navigator.userAgent);
  }, e.isIPad = function () {
    return /iPad|Intel Mac/.test(navigator.userAgent);
  }, e.isIPhone = function () {
    return /iPhone/.test(navigator.userAgent);
  }, e.isIPod = function () {
    return /iPod/.test(navigator.userAgent);
  }, e.iOSModel = function () {
    return this.isIPad() ? "iPad" : this.isIPhone() ? "iPhone" : this.isIPod() ? "iPod" : "";
  }, e.iOSVersion = function () {
    return navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
  }, e.manufacturer = function () {
    return this.isIOS() ? "Apple" : "";
  }, e.oSName = function () {
    return this.isIOS() ? "iOS" : "";
  }, e.oSVersion = function () {
    return this.isIOS() ? this.iOSVersion() : "";
  }, e.gpuRenderer = function () {
    if ("" !== this.gpu) return this.gpu;
    var e = document.createElement("canvas");

    if (e) {
      var t = e.getContext("webgl") || e.getContext("experimental-webgl");

      if (t) {
        var r = t.getExtension("WEBGL_debug_renderer_info");
        if (r) return this.gpu = t.getParameter(r.UNMASKED_RENDERER_WEBGL), this.loseContext(t), this.gpu;
        this.loseContext(t);
      }
    }

    return "unknown";
  }, e.webglFingerprint = function () {
    if (void 0 !== this.webglfp) return this.webglfp;
    if (!this.isIOS()) return "";

    try {
      var e = document.createElement("canvas");
      e.width = 256, e.height = 128;
      var t = e.getContext("webgl") || e.getContext("experimental-webgl"),
          r = t.createBuffer();
      t.bindBuffer(t.ARRAY_BUFFER, r);
      var i = new Float32Array([-.2, -.9, 0, .4, -.26, 0, 0, .7321, 0]);
      t.bufferData(t.ARRAY_BUFFER, i, t.STATIC_DRAW);
      var n = t.createProgram(),
          o = t.createShader(t.VERTEX_SHADER);
      t.shaderSource(o, "attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}"), t.compileShader(o);
      var a = t.createShader(t.FRAGMENT_SHADER);
      t.shaderSource(a, "precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}"), t.compileShader(a), t.attachShader(n, o), t.attachShader(n, a), t.linkProgram(n), t.useProgram(n);
      var s = t.getAttribLocation(n, "attrVertex"),
          u = t.getUniformLocation(n, "uniformOffset");
      t.enableVertexAttribArray(0), t.vertexAttribPointer(s, 3, t.FLOAT, !1, 0, 0), t.uniform2f(u, 1, 1), t.drawArrays(t.TRIANGLE_STRIP, 0, 3);
      var c = new Uint8Array(131072);
      t.readPixels(0, 0, 256, 128, t.RGBA, t.UNSIGNED_BYTE, c);
      var f = JSON.stringify(c).replace(/,?"[0-9]+":/g, "");
      this.webglfp = ts_md5_1.Md5.hashStr(f);
    } catch (e) {
      this.webglfp = e;
    }

    return this.webglfp;
  }, e.gpuScore = function () {
    if (void 0 !== this.gpuscore) return this.gpuscore;
    if (!this.isIOS()) return 0;
    var e = this.generateMatrices(),
        t = e.A,
        r = e.B,
        i = window.performance.now();
    this.multiplyMatrix(t, r);
    var n = window.performance.now() - i;
    return this.gpuscore = Math.round(1e4 / n), this.gpuscore;
  }, e.pageZoomFactor = function () {
    if (!this.isIOS()) return 1;
    if (0 === document.documentElement.clientWidth) return 1;
    var e = window.outerWidth / document.documentElement.clientWidth;
    return e || 1;
  }, e.multiplyMatrix = function (e, t) {}, e.generateMatrices = function () {
    for (var e = 512, t = [], r = [], i = 0; i < e * e; i++) {
      var n = Math.random(),
          o = Math.random();
      t.push(n), r.push(o);
    }

    function a(e, t) {
      for (var r = [], i = 0; i < e.length; i += t) {
        r.push(e.slice(i, i + t));
      }

      return r;
    }

    return {
      A: t = a(t, e),
      B: r = a(r, e)
    };
  }, e.loseContext = function (e) {
    var t = e.getExtension("WEBGL_lose_context");
    t && t.loseContext();
  }, e.gpu = "", e;
}();

exports.default = DeviceUtils;